let script_loaded = 1

function loadJSscripts ( e ) {
  setTimeout( function () {
    if ( script_loaded ) {
      script_loaded = 0
      var scripts   = document.getElementsByTagName( 'script' )
      for ( var i = 0; i < scripts.length; i++ ) {
        //exclude recharge widget
        if ( scripts[ i ].getAttribute( 'data-src' ) ) {
          scripts[ i ].setAttribute( 'src', scripts[ i ].getAttribute( 'data-src' ) )
          delete scripts[ i ].dataset.src
        }
      }

      var links = document.getElementsByTagName( 'link' )
      for ( var i = 0; i < links.length; i++ ) {
        if ( links[ i ].getAttribute( 'data-href' ) ) {
          links[ i ].setAttribute( 'href', links[ i ].getAttribute( 'data-href' ) )
          delete links[ i ].dataset.href
        }
      }

      setTimeout( function () {
        document.dispatchEvent( new CustomEvent( 'StartAsyncLoading' ) )
        document.dispatchEvent( new CustomEvent( 'StartKernelLoading' ) )
      }, 400 )

      console.log( 'Shopioso scripts loaded with loadJSscripts' )
    }
    console.log( 'Waiting 123ms before trying again.' )
  }, 123 )
}

function loadJSscriptsNow ( e ) {
  if ( script_loaded ) {
    console.log( 'Shopioso scripts have loaded.' )
    script_loaded = 0
    var scripts   = document.getElementsByTagName( 'script' )
    for ( var i = 0; i < scripts.length; i++ ) {
      //exclude recharge widget
      if ( scripts[ i ].getAttribute( 'data-src' ) ) {
        scripts[ i ].setAttribute( 'src', scripts[ i ].getAttribute( 'data-src' ) )
        delete scripts[ i ].dataset.src
      }
    }

    var links = document.getElementsByTagName( 'link' )
    for ( var i = 0; i < links.length; i++ ) {
      if ( links[ i ].getAttribute( 'data-href' ) ) {
        links[ i ].setAttribute( 'href', links[ i ].getAttribute( 'data-href' ) )
        delete links[ i ].dataset.href
      }
    }

    setTimeout( function () {
      document.dispatchEvent( new CustomEvent( 'StartAsyncLoading' ) )
      document.dispatchEvent( new CustomEvent( 'StartKernelLoading' ) )
    }, 400 )
  }
}

var activityEvents = [ 'mousedown', 'mousemove', 'scroll', 'keydown', 'touchstart', 'click', 'keypress', 'touchmove' ]
activityEvents.forEach( function ( eventName ) {
  window.addEventListener( eventName, loadJSscriptsNow, { once: true } )
} )

document.addEventListener( 'DOMContentLoaded', loadJSscripts )
window.addEventListener ? window.addEventListener( 'load', loadJSscripts ) : window.attachEvent ? window.attachEvent( 'onload', loadJSscripts ) : window.onload = loadJSscripts
